/* Display-only wallet labels. Shopify remains the owner of native payments. */
(function () {
  if (window.EssentialsVault?.compactCart) return;
  window.EssentialsVault = window.EssentialsVault || {};
  function sync() {
    const ua = navigator.userAgent || '';
    const apple = /iPhone|iPad|iPod|Macintosh/.test(ua)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const name = apple ? 'apple_pay' : /Android/i.test(ua) ? 'google_pay' : null;
    document.querySelectorAll('cart-drawer [data-cart-methods]').forEach((methods) => {
      const label = methods.querySelector('[data-cart-wallet-label]');
      if (!label) return;
      let available = false;
      // The cart's express button is intentionally hidden. This informational
      // label describes the payment method still available in final checkout.
      if (apple) {
        try { available = Boolean(window.ApplePaySession?.canMakePayments?.()); }
        catch (_) { available = false; }
      } else if (name) document.querySelectorAll('[wallet-configs]').forEach((host) => {
        try { available ||= JSON.parse(host.getAttribute('wallet-configs') || '[]').some(config => config.name === name); }
        catch (_) { /* Unknown SDK payload: keep the copy conservative. */ }
      });
      const text = available ? apple ? 'Apple Pay' : 'Google Pay' : '';
      if (label.textContent !== text) label.textContent = text;
      label.hidden = !available;
    });
  }
  sync();
  const observer = new MutationObserver(sync);
  observer.observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['wallet-configs']});
  window.EssentialsVault.compactCart = {sync, disconnect: () => observer.disconnect()};
})();
